import { SmallLoader } from 'components/shared/Loader';
import React, { useState } from 'react';
import FeatureConfigureModal from './FeatureConfigureModal';
import UsageLimits from './UsageLimits';
import { FiEdit } from 'react-icons/fi';


export interface FeatureList {
    id: string;
    feature: string;
    unit: string;
    cost: string;
}


const Feature = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [featureList, setFeatureList] = useState<FeatureList[]>([
        {
            id: "1",
            feature: "Create digital twins",
            unit: "Number",
            cost: "$200"
        },
        {
            id: "2",
            feature: "Manage Tickets",
            unit: "Number",
            cost: "$15"
        },
        {
            id: "3",
            feature: "Create something twins",
            unit: "Number",
            cost: "$200"
        },
        {
            id: "4",
            feature: "Manage ",
            unit: "Number",
            cost: "$15"
        }
    ]);
    const [mode, setMode] = useState("add");
    const [editItemId,setEditItemId] = useState("");

    const [currentPage, setCurrentPage] = useState(1); // starts from 1
    const itemsPerPage = 2; // you can change this number

    const totalPages = Math.ceil(featureList.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentDiscountCodes = featureList.slice(startIndex, endIndex);
    const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

    const handleConfigureOpen = () => {
        setIsOpen(true);
        setMode("add");
    };

    const handleEditConfigure = (id: string) => {
        setMode("edit");
        setEditItemId(id);
        setIsOpen(true);
    };


    return (
        <>
            <div className="w-full mt-10">
                <div className="flex justify-between items-center mb-5">
                    <h1 className="text-lg font-semibold text-white">Feature list</h1>
                    <button
                        onClick={handleConfigureOpen}
                          className="flex items-center gap-2 px-4 py-2 bg-[#2A2A2A] text-white rounded-lg hover:bg-[#3a3a3a33] transition-colors"
                    >

                        Configure
                    </button>
                </div>

                <div className="bg-[#2A2A2A]  overflow-hidden rounded-lg">
                    <div className="w-full overflow-x-auto bg-[#2A2A2A] ">
                        <table className="min-w-full ">
                            <thead className="bg-[#1A1A1A]">
                                <tr >
                                    <th className="text-left p-4 font-medium">
                                        Feature
                                    </th>
                                    <th className="text-left p-4 font-medium">
                                        Unit
                                    </th>
                                    <th className="text-left p-4 font-medium">
                                        Cost
                                    </th>
                                    <th className="text-right p-4 font-medium">
                                    Actions
                                </th>
                                </tr>
                            </thead>
                            <tbody className="">
                                {isLoading ? (
                                    <tr>
                                        <td colSpan={7} className="px-6 py-4 text-center">
                                            <div className="flex justify-center">
                                                <SmallLoader />
                                            </div>
                                        </td>
                                    </tr>
                                ) : featureList.length === 0 ? (
                                    <tr>
                                        <td colSpan={7} className="px-6 py-4 text-center text-gray-400">
                                            No discount codes found
                                        </td>
                                    </tr>
                                ) : (
                                    currentDiscountCodes.map((feature) => (
                                        <tr key={feature.id} className='border-b border-white/[0.08] hover:bg-[#3a3a3a33]'>
                                            <td className="p-4 text-gray-300">
                                                {feature.feature}
                                            </td>
                                            <td className="p-4 text-gray-300">
                                                {feature.unit}
                                            </td>
                                            <td className="p-4 text-gray-300">
                                                {feature.cost}
                                            </td>
                                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                                            <div className="flex justify-end gap-3">
                                                <button
                                                    onClick={() => handleEditConfigure(feature.id)}
                                                    className="text-blue-500 hover:text-blue-400"
                                                >
                                                    <FiEdit size={18} />
                                                </button>
                                                {/* <button
                                                    onClick={() => openDeleteModal(code.id)}
                                                    className="text-red-500 hover:text-red-400"
                                                >
                                                    <FiTrash2 size={18} />
                                                </button> */}
                                            </div>
                                        </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {isOpen && <FeatureConfigureModal setDataList={setFeatureList} mode={mode} setMode={setMode} editItemId={editItemId} dataList={featureList} setData={(newItems: FeatureList[]) =>
                    setFeatureList((prev) => [...prev, ...newItems])
                } type="feature-list" isOpen={isOpen} onClose={() => setIsOpen(false)} />}


                {/* Pagination */}
                <div className="flex items-center justify-between mt-4 text-sm text-gray-400">
                    <div>
                        Showing {startIndex + 1}-{Math.min(endIndex, featureList.length)} from {featureList.length}
                    </div>
                    <div className="flex items-center gap-2">
                        <button
                            onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                            disabled={currentPage === 1}
                            className="p-2 hover:text-white disabled:opacity-50"
                        >
                            ←
                        </button>
                        {pages.map(page => (
                            <button
                                key={page}
                                onClick={() => setCurrentPage(page)}
                                className={`w-8 h-8 rounded flex items-center justify-center ${currentPage === page
                                    ? 'bg-[#3A3A3A] text-white'
                                    : 'hover:text-white'
                                    }`}
                            >
                                {page}
                            </button>
                        ))}
                        <button
                            onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                            disabled={currentPage === totalPages}
                            className="p-2 hover:text-white disabled:opacity-50"
                        >
                            →
                        </button>
                    </div>
                </div>


            </div>
            <div className="mt-10">
                <UsageLimits />
            </div>
        </>
    );
};

export default Feature;
